export default __webpack_public_path__ + "static/media/Easter bunny wreath1.5577dbb1.jpg";